import React, { useEffect, useState } from "react";
import { Tokens } from "@chainsafe/web3-context/dist/context/tokensReducer";
import { Menu, MenuButton, MenuList, MenuItem } from "@chakra-ui/menu";
import { Button } from "@chakra-ui/button";
import { Input } from "@chakra-ui/input";
import VisuallyHidden from "@chakra-ui/visually-hidden";
import { UseFormRegister, UseFormSetValue } from "react-hook-form";
import { ChevronDownIcon } from "@chakra-ui/icons";
import {
  NFTTokenDeclaration,
  useChainbridge,
} from "../../Contexts/ChainbridgeContext";
import { BigNumber } from "ethers";

interface ITokenSelectInput {
  name: string;
  selectedTokenIds?: Array<BigNumber>;
  selectedTokenId?: string;
  sync?: (value: string) => void;
  isDisabled: boolean;
  register: UseFormRegister<any>;
  value: string;
  setValue: UseFormSetValue<any>;
}

const NFTTokenIdSelectInput: React.FC<ITokenSelectInput> = ({
  name,
  selectedTokenIds,
  selectedTokenId,
  sync,
  isDisabled,
  register,
  setValue,
  value,
}: ITokenSelectInput) => {
  const handleClick = (selectedValue: string) => {
    setValue(name, selectedValue, { shouldValidate: true }); // Form validation
    if (sync) {
      sync(selectedValue);
    }
  };

  const labelParsed =
    value !== "" && selectedTokenId
      ? `${selectedTokenId.toString()}`
      : "Select NFT id";

  const tokenIdValidator = register(name);

  return (
    <section>
      <Menu gutter={0} matchWidth={true}>
        <MenuButton width="100%" as={Button} rightIcon={<ChevronDownIcon />}>
          {labelParsed}
        </MenuButton>
        <MenuList borderRadius="0px" border="1px solid">
          {(selectedTokenIds || []).map((tokenId: BigNumber) => {
            return (
              <MenuItem
                onClick={handleClick.bind(this, tokenId.toString())}
                key={"id" + tokenId.toString()}
              >
                {tokenId.toString()}
              </MenuItem>
            );
          })}
        </MenuList>
      </Menu>
      {/* Hidden text field for form validation: */}
      <VisuallyHidden>
        <Input
          name={name}
          value={selectedTokenId || ""}
          onChange={tokenIdValidator.onChange}
          onBlur={tokenIdValidator.onBlur}
          ref={tokenIdValidator.ref}
        />
      </VisuallyHidden>
    </section>
  );
};

export default NFTTokenIdSelectInput;
